import React, { useEffect, useRef } from 'react';
import { useGame } from '../context/GameContext.jsx';
import Card from './Card.jsx'; // Reutilizando o componente Card

const LastScannedCardScreen = () => {
  const { translations, lang, lastScannedCardCode, currentCards } = useGame(); 
  const cardImageRef = useRef(null); // Ref para a imagem da carta

  // Encontra a última carta escaneada na lista de cartas atuais
  const lastScannedCard = lastScannedCardCode 
    ? currentCards.find(card => card.CardId === lastScannedCardCode) 
    : null;

  useEffect(() => {
    if (lastScannedCard && cardImageRef.current) {
      cardImageRef.current.focus(); // Foca na imagem da carta
    }
  }, [lastScannedCard]); // Foca sempre que a carta escaneada mudar

  if (!lastScannedCard) {
    return (
      <div className="screen-content text-center mt-5">
        <p className="text-light">{translations[lang]?.no_qr_code_scanned}</p>
      </div>
    );
  }

  return (
    <div className="last-scanned-card-screen-content d-flex flex-column align-items-center">
      <Card card={lastScannedCard} isMissionCard={false} ref={cardImageRef} /> {/* Passa a ref para o Card */}
    </div>
  );
};

export default LastScannedCardScreen;
